export const PREVIEW_CONSTS = {
  SUBTOTAL: 13.14,
  TAX: 2.36,
  TOTAL: 15.5
};

export const previewExampleItems = [
  { label: 'Coins', qty: '6,580', emoji: '🪙', bg: '#FFF3D6' },
  { label: 'Tokens', qty: '150', emoji: '🎟️', bg: '#F1F0FF' },
  { label: 'Boosters', qty: '3', emoji: '🔵', bg: '#E7F3FF' }
];
